/**
 * @generated SignedSource<<d9d07faeabbd1a9a28c6f871a29f0363>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RepeatTypeEnum = "daily" | "monthly" | "weekly" | "%future added value";
export type PromotionCreateInput = {
  endAt: any;
  isRepeat: boolean;
  priority: number;
  query: string;
  repeatType?: RepeatTypeEnum | null;
  repeatValue?: string | null;
  startAt: any;
  title: string;
};
export type PromotionCreateDialog_promotionCreateMutation$variables = {
  input: PromotionCreateInput;
};
export type PromotionCreateDialog_promotionCreateMutation$data = {
  readonly promotionCreate: {
    readonly id: string;
  };
};
export type PromotionCreateDialog_promotionCreateMutation = {
  response: PromotionCreateDialog_promotionCreateMutation$data;
  variables: PromotionCreateDialog_promotionCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Promotion",
    "kind": "LinkedField",
    "name": "promotionCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionCreateDialog_promotionCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionCreateDialog_promotionCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b7f667343cf654420bd8e58fc8654532",
    "id": null,
    "metadata": {},
    "name": "PromotionCreateDialog_promotionCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionCreateDialog_promotionCreateMutation(\n  $input: PromotionCreateInput!\n) {\n  promotionCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "740d719d76912874678fa994bfec677b";

export default node;
